import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

@Injectable()
export class ReservationsGuard implements CanActivate{
  constructor(){}

  canActivate() {
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/reservations.guard.ts